exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-731a7c86]:hover {\n  text-decoration: none;\n}\n.header-title[data-v-731a7c86] {\n  padding: 0;\n  list-style: none;\n}", ""]);

// exports
